import { render } from "./SubNetworkAddRenameModal.vue?vue&type=template&id=b0326650"
import script from "./SubNetworkAddRenameModal.vue?vue&type=script&lang=js"
export * from "./SubNetworkAddRenameModal.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__